import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    secs
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: secs,
    label: 'Sec'
  }];
  const dark = tone === 'dark';
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-19" data-mp="3c0kwtkd5gh27">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] ${dark ? 'text-blush' : 'text-forest'}`} data-id="element-20" data-mp="3h2k0kvcsxfzo">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="3262r69o6abfr" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-22" data-mp="10cbubkmtn7gd">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="10aina48aql7u" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="15adc828ih0q9">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-serif text-3xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${dark ? 'bg-cream text-forest' : 'bg-forest text-cream'}`} data-id="element-25" data-mp="159263vrlfgvz">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? 'text-cream/70' : 'text-muted'}`} data-id="element-26" data-mp="12t7siioal8ae">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-2xl font-bold sm:pt-5 ${dark ? 'text-cream' : 'text-forest'}`} data-id="element-27" data-mp="a5kdrk9pdbvo">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}